import React from "react";
import Dialog from "@mui/material/Dialog";
import CircularProgress from "@mui/material/CircularProgress";
import { apiPost } from "../api";

const getCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
  }
  return null;
};

// Propaga el error en vez de devolver []: al cambiar de estado el usuario tiene
// que enterarse si fallo, no quedarse mirando una pantalla que no cambio.
const changeState = (data, estado) => {
  const body = data.tipo_instalacion === "OTRA"
    ? { denominacion: data.denominacion, tipo_cruce: data.tipo_cruce, tipo_instalacion: data.tipo_instalacion, detalle_instalacion: data.detalle_instalacion, id: data.id, estado }
    : { denominacion: data.denominacion, tipo_cruce: data.tipo_cruce, tipo_instalacion: data.tipo_instalacion, id: data.id, estado };
  return apiPost(process.env.REACT_APP_API_SAVE, body);
};

const XIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 6L6 18M6 6l12 12"/>
  </svg>
);
const SettingsIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3"/>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
  </svg>
);
const BuildIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 20h.01M7 20v-4"/><path d="M12 20V10"/><path d="M17 20V4"/>
    <path d="M22 20h.01"/>
  </svg>
);
const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 6L9 17l-5-5"/>
  </svg>
);
const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14M13 6l6 6-6 6"/>
  </svg>
);

const STEPS = [
  { icon: <SettingsIcon />, label: "Habilitado", sub: "Apto para inicio" },
  { icon: <BuildIcon />,    label: "Obra en ejecución", sub: "En curso" },
  { icon: <CheckIcon />,   label: "Obra finalizada", sub: "Cierre y CAO" },
];

export default function DraggableDialog(props) {
  const [activeStep, setActiveStep] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [done, setDone] = React.useState(false);

  const handleNext = () => {
    setLoading(true);
    const estado = activeStep === 0 ? "Obra en ejecucion" : "Obra finalizada";
    changeState(props.clickRow.solicitud.attributes, estado).then(x => {
      if (x.length !== 0) {
        props.setNuevaSolicitudes(Math.random());
        const next = activeStep + 1;
        setActiveStep(next);
        if (next >= 2) setDone(true);
        if (x.attributes?.estado === "Esperando CAO") {
          alert(`La solicitud ${x.attributes.id} está lista para la carga de documentación CAO.`);
        }
      }
      props.setChangeState(false);
      setLoading(false);
    }).catch(err => {
      setLoading(false);
      props.setChangeState(false);
      if (err?.sesionVencida) return;
      window.alert(err?.message || 'No se pudo cambiar el estado de la solicitud.');
    });
  };

  const handleClose = (_, reason) => {
    if (reason === 'backdropClick') return;
    props.setChangeState(false);
  };

  React.useEffect(() => {
    if (!props.clickRow) return;
    const estado = props.clickRow.solicitud.attributes.estado;
    setDone(false);
    if (estado === "Habilitado") setActiveStep(0);
    else if (estado === "Obra en ejecucion") setActiveStep(1);
  }, [props.changeState]);

  const progressWidths = ['0%', '34%', '68%'];
  const nextLabel = activeStep === 0 ? 'Pasar a "Obra en ejecución"' : 'Pasar a "Obra finalizada"';

  return (
    <Dialog
      open={props.changeState}
      onClose={handleClose}
      // Evita que la pagina de atras se corra al abrir el modal (MUI bloquea el
      // scroll del body y compensa la barra con padding-right).
      disableScrollLock
      PaperProps={{ style: { width: 680, maxWidth: '95vw', borderRadius: 13 } }}
    >
      {/* Header */}
      <div className="ds-modal-head">
        <div>
          <div className="ds-modal-title">Avance de obra</div>
          {props.clickRow && (
            <div className="ds-modal-sub">
              Solicitud {props.clickRow.solicitud.attributes.id} · {props.clickRow.solicitud.attributes.denominacion}
            </div>
          )}
        </div>
        <div className="ds-modal-x" onClick={() => props.setChangeState(false)}><XIcon /></div>
      </div>

      {/* Body: stepper */}
      <div style={{ padding: '36px 40px 28px', position: 'relative' }}>
        {loading && (
          <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.8)', zIndex: 5, borderRadius: 'inherit' }}>
            <CircularProgress size={36} />
          </div>
        )}

        {/* Stepper */}
        <div className="ds-stepper-wrap">
          <div className="ds-stepper-track" />
          <div className="ds-stepper-progress" style={{ width: progressWidths[activeStep] }} />
          {STEPS.map((step, i) => {
            const isDone = i < activeStep;
            const isCurr = i === activeStep;
            return (
              <div className="ds-step" key={i}>
                <div className={`ds-step-node${isDone ? ' done' : isCurr ? ' curr' : ''}`}>
                  {step.icon}
                </div>
                <div className={`ds-step-label${isDone || isCurr ? ' active' : ''}`}>{step.label}</div>
                <div className="ds-step-sub">{step.sub}</div>
              </div>
            );
          })}
        </div>

        {/* Info box */}
        {!done && (
          <div className="ds-info-box" style={{ marginTop: 24 }}>
            <BuildIcon />
            <p>
              Estado actual: <b>{STEPS[activeStep]?.label}</b>.
              {activeStep < 2 && ' Usá el botón de abajo para avanzar al siguiente estado cuando corresponda.'}
            </p>
          </div>
        )}
        {done && (
          <div className="ds-info-box" style={{ marginTop: 24, background: 'var(--st-ok-bg)', borderColor: '#b8e0cf' }}>
            <CheckIcon />
            <p style={{ color: 'var(--st-ok)' }}>
              <b>Obra finalizada.</b> Procedé a cargar la documentación CAO desde el menú de documentación.
            </p>
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="ds-modal-foot">
        <button className="ds-btn ds-btn-ghost" onClick={() => props.setChangeState(false)}>Cerrar</button>
        {!done && (
          <button className="ds-btn ds-btn-primary" onClick={handleNext} disabled={loading}>
            {nextLabel} <ArrowIcon />
          </button>
        )}
      </div>
    </Dialog>
  );
}
